import {
  MachineDesignsApi,
  ReportingMelcoMachineStatisticsModelsMachineDesignListItem,
  useAPIQuery,
  useTable,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";
import { useTableErrorComponent } from "../table/useTableErrorComponent";

export const useDesigns = () => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQuery,
    searchQueryChange,
  } = useTable<ReportingMelcoMachineStatisticsModelsMachineDesignListItem>();

  const query = useAPIQuery(
    MachineDesignsApi,
    ["designs", currentPage, pageSize, filters, sortBy(), searchQuery],
    async (api: MachineDesignsApi) => {
      const response = await api.machineDesignsSearch({
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        sortBy: sortBy(),
        searchText: !isEmpty(searchQuery) ? searchQuery : undefined,
      });

      setTotal(response.total);

      return response.list;
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    searchQuery,
    searchQueryChange,
    errorComponent,

    ...query,
  };
};
